<template lang="pug">
.section.content
  div.has-text-weight-semibold Have a question?
  template(v-if="isDwffOperator")
    p If you need any help, or are experiencing issues with this app, please call us on <a href='tel:0203 314 8180'>0203 314 8180</a> or email <a href='mailto:hello@godo.fitness'>hello@godo.fitness</a>.
  template(v-else-if="isStarOperator")
    p To get in touch with STARS Gym, please call <a href='tel:020 7223 6913'>020 7223 6913</a> or email <a href='mailto:info@starsgym.co.uk'>info@starsgym.co.uk</a>.
    p If you are experiencing issues with this app, or have questions or feedback, please call us on <a href='tel:0203 314 8180'>0203 314 8180</a> or email <a href='mailto:hello@godo.fitness'>hello@godo.fitness</a>.
  template(v-else)
    p Get in touch with us about anything to do with Personal Training. We want to hear your feedback, tips and advice to make Go:Do the best PT App in the UK. For all enquiries <a href='mailto:hello@godo.fitness'>hello@godo.fitness</a> or call us on <a href='tel:0203 314 8180'>0203 314 8180</a>. We'd love to hear from you!
</template>

<script>
import ApiMixin from '@/mixins/ApiMixin.vue'

export default {
  mixins: [
    ApiMixin
  ]
}
</script>
